import { api } from './api';

export type AnalyticsEventName =
  | 'page_view'
  | 'view_item'
  | 'add_to_cart'
  | 'remove_from_cart'
  | 'view_cart'
  | 'begin_checkout'
  | 'add_payment_info'
  | 'purchase'
  | 'sign_up'
  | 'login'
  | 'search';

export const analyticsService = {
  track(name: AnalyticsEventName, extra?: { path?: string; value?: number; metadata?: Record<string, unknown> }) {
    try {
      return api
        .post('/analytics/track', { name, ...extra })
        .catch(() => undefined);
    } catch {
      return Promise.resolve(undefined);
    }
  },
};
